import validator from "validator";
import { Link } from "react-router-dom";
import Modal from "@mui/material/Modal";
import { IconButton } from "@mui/material";
import TextField from "@mui/material/TextField";
import Select, { components } from "react-select";
import React, { useState, useEffect, useRef } from "react";
import Input from "react-phone-number-input/input";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { trackButtonClick } from '../../../utils/gtm';

import * as ROUTES from "../../../constants/routes";
import ModalWrapper from "../../common/Modal/ModalWrapper";
import { updateUser } from '../../../reducers/userReducer';
import { setLoginType } from "../../../reducers/loginReducer";
import { updatePartner } from "../../../reducers/partnerReducer.js";
import { updateCompany } from "../../../reducers/companyReducer";
import { getRequest, postRequest, showMessage } from "../../../config";
import { setModalHistory, toggleModal } from "../../../reducers/modalReducer";
import { fetchCategories, UPDATE_CATEGORIES, } from "../../../reducers/commonReducer";


const PlusIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width="30px"
            height="30px"
        >
            <path
                fill="#fd6474"
                d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
            />
            <path fill="#fff" d="M21,14h6v20h-6V14z" />
            <path fill="#fff" d="M14,21h20v6H14V21z" />
        </svg>
    );
};

const RegisterTwoMinuteTest = ({ registerationType, refs, isAnimationVisible, registerPage, }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const user = useSelector((state) => state.user);
    const modal = useSelector((state) => state.modal);
    const partner = useSelector((state) => state.partner);

    const { categories } = useSelector((state) => state.common);
    const { selectedCompany } = useSelector((state) => state.company);
    const advisorsCategories = categories.filter((cat) => cat?.for === "advisor")
    const investorsCategories = categories.filter((cat) => cat?.for === "investor")

    let [type, setType] = useState();
    let [stepNo, setStepNo] = useState(1);
    let [company, setCompany] = useState({});
    let [partnerId, setPartnerId] = useState();
    let [animation, setAnimation] = useState(1);
    let [isAgreed, setIsAgreed] = useState(false);
    let [attachment, setAttachment] = useState([]);
    let [isNotSure, setIsNotSure] = useState(false);
    let [isLoading, setIsLoading] = useState(false);
    let [isBtnHover, setIsBtnHover] = useState(false);
    let [registerAs, setRegisterAs] = useState("User");
    let [isGuestUser, setIsGuestUser] = useState(false);

    let [advisorType, setAdvisorType] = useState(false);
    let [passwordType, setPasswordType] = useState(true);
    let [companyOptions, setCompanyOptions] = useState([]);
    let [companySelected, setCompanySelected] = useState({});
    let [advisorHashData, setAdvisorHashData] = useState("");
    let [existingAdvisor, setExistingAdvisor] = useState({});
    let [websiteStatus, setWebsiteStatus] = useState("Check");
    let [advisorTypeValue, setAdvisorTypeValue] = useState("");
    let [selectedAdvisorType, setSelectedAdvisorType] = useState(null);

    let [investorType, setInvestorType] = useState(false);
    let [selectedInvestorType, setSelectedInvestorType] = useState(null);

    let [isValidPassword, setIsValidPassword] = useState(false);
    let [confirmPasswordType, setConfirmPasswordType] = useState(true);
    let [passwordError, setPasswordError] = useState({ password: "", confirmPassword: "", });
    let [formData, setFormData] = useState({ role: "", firstName: "", lastName: "", email: selectedCompany["companyEmail"] || "", password: "", confirmPassword: "", title: "", phone: "", firmName: "", company5Words: "", firmAddress: "", website: "", firmLogo: "", testType: "", });

    let searchTimeout;
    let formCheck = ["firstName", "lastName", "email", "password", "confirmPassword",];
    let passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`])[A-Za-z\d!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`]+$/;

    useEffect(() => {
        let pathname = window.location.pathname;
        if (pathname.includes('register')) {
            let userAgent = navigator.userAgent || navigator.vendor || window.opera;
            let mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
            let isMobile = mobileRegex.test(userAgent);
            if (isMobile) dispatch(toggleModal({ open: 'mobileDevicesPopup' }));
        }
    }, []);

    useEffect(() => {
        if (location?.hash) {
            partnerId = location?.hash.split('?')[0];
            partnerId = partnerId.replaceAll('#', '');
            if (partnerId) setPartnerId(partnerId);

            type = location?.hash.split('?')[1];
            if (type == 'Superflow') setType(type);
        }
        if (localStorage.getItem("companyId")) getUser();
        if (localStorage.getItem("isPartnerChecklist")) {
            setRegisterAs("User");
            if (!partner["referralCode"]) {
                let partnerId = localStorage.getItem("partnerId");
                if (partnerId) getPartner(partnerId);
            } else
                setFormData({ ...formData, referralCode: partner["referralCode"] });
        }
    }, []);

    useEffect(() => {
        let companyId = localStorage.getItem("companyId");
        if (user?.['role'] == 'Guest' && companyId) setIsGuestUser(true);
        else setIsGuestUser(false);
    }, [user]);

    useEffect(() => {
        if (selectedCompany["companyEmail"])
            setFormData({ ...formData, email: selectedCompany["companyEmail"] });
    }, [selectedCompany]);

    const getUser = async () => {
        let response = await getRequest(`/user`);
        if (response && response['code'] == 200) {
            let user = response?.['body']?.['user'];
            dispatch(updateUser(user));
        }
    };

    const getPartner = async (id) => {
        let res = await getRequest(`/checklist/partner/${id}`);
        if (res["code"] == 200) {
            dispatch(updatePartner(res["body"]));
            setFormData({ ...formData, referralCode: res["body"]["referralCode"] });
        }
    };

    const CustomOption = (props) => {
        const { data, innerRef, innerProps } = props;
        return data.hasAdd ? (
            <div
                className="df jcsb aic"
                ref={innerRef}
                {...(advisorTypeValue ? innerProps : {})}
            >
                <div
                    style={{
                        marginLeft: "11px",
                        color: advisorTypeValue === "" && "gray",
                    }}
                >
                    {data.label}
                </div>
                <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    onClick={(event) => {
                        event.stopPropagation();
                        event.preventDefault();
                        dispatch(toggleModal({ open: "advisorType" }));
                    }}
                >
                    <PlusIcon />
                </IconButton>
            </div>
        ) : (
            <>
                <components.Option {...props} />
            </>
        );
    };

    // Custom react select
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            cursor: "pointer",
            border: "none",
            boxShadow: "none",
            minHeight: "initial",
        }),
        valueContainer: (provided) => ({
            ...provided,
        }),
        input: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0,
        }),
        placeholder: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0,
            fontSize: "10px",
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: 0,
        }),
        indicatorSeparator: () => ({
            display: "none",
        }),
        menu: (provided, state) => ({
            ...provided,
            width: "96%",
            marginTop: 0,
            fontSize: "12px",
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#fc7785"
                : state.isFocused
                    ? "#fde3e6"
                    : provided.backgroundColor,
            color: state.isSelected ? "white" : provided.color,
            fontSize: "12px",
            ":active": {
                ...provided[":active"],
                backgroundColor: state.isSelected ? "#fc7785" : "#fde3e6",
            },
        }),
    };

    useEffect(() => {
        let pathname = window.location.pathname;
        if (pathname && pathname == "/register") setIsNotSure(false);
        else setIsNotSure(true);

        registerAs = localStorage.getItem('registerAs');
        if (registerAs) setRegisterAs(registerAs);
        if (registerAs == 'Advisor') setAdvisorType(true);
        if (registerAs == 'Investor') setInvestorType(true)
        const timeout = setTimeout(() => {
            setAnimation(true);
        }, 2000);
        return () => clearTimeout(timeout);
    }, []);

    useEffect(() => {
        if (dispatch) {
            dispatch(fetchCategories());
        }
    }, [dispatch]);

    //Reseting all advisor type select to intial if radio button change
    useEffect(() => {
        setSelectedAdvisorType(null);
        setAdvisorTypeValue("");
        setSelectedInvestorType(null);
    }, [registerAs]);

    //Handle on advisor type added
    const onAdvisorTypeAdded = async () => {
        let res = await postRequest(`/admin/create/custom-category`, {
            name: advisorTypeValue,
        });
        if (res?.code === 200) {
            showMessage(res["message"]);
            dispatch(toggleModal({ open: "" }));
            const newCategories = res?.body
                ? {
                    ...res.body,
                    label: res.body.name,
                    value: res.body._id,
                }
                : {};
            dispatch(UPDATE_CATEGORIES([newCategories, ...categories]));
        }
    };

    //On advisor modal close
    const onAdvisorModalClose = () => {
        dispatch(toggleModal({ open: "" }));
        setSelectedAdvisorType(null);
        setAdvisorTypeValue("");
    };

    useEffect(() => {
        setFormData({ ...formData, role: registerationType });
    }, []);

    useEffect(() => {
        if (!formData?.["firmName"] || formData?.["firmName"] == "") {
            setCompanyOptions([]);
            setCompanySelected({});
        }
    }, [formData?.["firmName"]]);

    const resetStates = () => {
        setStepNo(1);
        setIsAgreed(false);
        setCompanyOptions([]);
        setCompanySelected({});
        setWebsiteStatus("Check");
        setIsValidPassword(false);
        setFormData({
            role: "",
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            confirmPassword: "",
            title: "",
            phone: "",
            firmName: "",
            firmAddress: "",
            website: "",
            firmLogo: "",
        });
    };

    const handleRegisterAs = (value) => {
        setAdvisorType(value === "Advisor");
        setInvestorType(value === "Investor");

        setRegisterAs(value);
        setFormData({ ...formData, role: value });
        setStepNo(1);
        setIsAgreed(false);
        setCompanyOptions([]);
        setCompanySelected({});
        setWebsiteStatus("Check");
        trackButtonClick('register_as_selection', {
            registration_type: value,
            step: stepNo
        });
    };

    const handlePasswordBlur = (type) => {
        let errors = { ...passwordError };

        if (type === "password") {
            if (formData?.["password"] === "" || formData?.["password"].length < 8) {
                errors["password"] = "Password must be 8 characters long";
            } else if (!passwordPattern.test(formData?.["password"])) {
                errors["password"] =
                    "Combination of uppercase, lowercase, digit & special character is required";
            } else {
                errors["password"] = "";
            }
        }

        if (
            type === "confirmPassword" ||
            (formData?.["password"] && formData?.["confirmPassword"])
        ) {
            if (formData?.["password"] === "" || formData?.["password"].length < 8) {
                errors["password"] = "Password must be 8 characters long";
            } else if (formData?.["password"] !== formData?.["confirmPassword"]) {
                errors["confirmPassword"] = "Password and Confirm Password don't match";
            } else if (!passwordPattern.test(formData?.["password"])) {
                errors["password"] =
                    "Combination of uppercase, lowercase, digit & special character is required";
            } else {
                errors["confirmPassword"] = "";
            }
        }

        setPasswordError(errors);

        if (!errors["password"] && !errors["confirmPassword"]) {
            setIsValidPassword(true);
        }
    };

    const searchCompany = async (input) => {
        if (!input) return;

        const response = await getRequest(`/company/search/${input}`);
        if (!response || response["code"] != 200) return;
        setCompanyOptions(response["body"]["items"].slice(0, 5));
    };

    const searchCompanyTimeout = (e) => {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => searchCompany(e.target.value), 1000);
    };

    const requestAdvisorAccess = async () => {
        trackButtonClick('request_advisor_access');
        let data = {
            firmId: existingAdvisor["_id"],
            firmName: existingAdvisor["cName"],
            contactId: existingAdvisor["contactId"],
            contactName: existingAdvisor["contactName"],
            contactEmail: existingAdvisor["contactEmail"],
            userFirstName: formData["firstName"],
            userLastName: formData["lastName"],
            userEmail: formData["email"],
        };

        let response = await postRequest(`/company/requestInvestorAccess`, data);
        if (response["code"] == 200) {
            showMessage(response["message"]);
            dispatch(toggleModal({ open: "" }));
            resetStates();
        }
    };

    const isURL = (str) => {
        var pattern = new RegExp(
            "^((ft|htt)ps?:\\/\\/)?" + // protocol
            "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name and extension
            "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
            "(\\:\\d+)?" + // port
            "(\\/[-a-z\\d%@_.~+&:]*)*" + // path
            "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
            "(\\#[-a-z\\d_]*)?$",
            "i"
        ); // fragment locator
        return pattern.test(str);
    };

    const openWindow = (url) => {
        if (window.innerWidth <= 640) {
            var a = document.createElement("a");
            a.setAttribute("href", url);
            a.setAttribute("target", "_blank");

            var dispatch = document.createEvent("HTMLEvents");
            dispatch.initEvent("click", true, true);

            a.dispatchEvent(dispatch);
        } else {
            var width = window.innerWidth * 0.8;
            var height = (width * window.innerHeight) / window.innerWidth;
            window.open(url, "newwindow", "width=" + width + ", height=" + height + ", top=" + (window.innerHeight - height) / 2 + ", left=" + (window.innerWidth - width) / 2);
        }
        return false;
    };

    const verifyWebsite = async () => {
        trackButtonClick('verify_website', {
            website: formData['website']
        });
        try {
            let companyWebsite = document.querySelector(`#companyWebsite`).value;
            if (!companyWebsite) return showMessage("Please provide website link");
            if (!isURL(companyWebsite)) return showMessage("Invalid company url");

            if (companyWebsite.indexOf("http") < 0)
                companyWebsite = `http://${companyWebsite}`;

            openWindow(companyWebsite);
            setWebsiteStatus("Confirm");
        } catch (e) {
            return showMessage(e);
        }
    };

    const onDragOver = (e) => e.preventDefault();
    const onDrop = (e) => {
        e.preventDefault();
        const logo = e.dataTransfer.files[0];
        let maxSizeInBytes = 5 * 1024 * 1024;
        if (logo) {
            let logoUrl = URL.createObjectURL(logo);
            let img = document.createElement("img");
            img.src = logoUrl;
            img.onload = () => {
                if (logo.size > maxSizeInBytes)
                    showMessage(`File size must be less than 1MB`);
                else
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        firmLogo: logoUrl,
                    }));
            };
        }
        trackButtonClick('register_image_drop', {
            step: stepNo,
            file_type: e.dataTransfer.files[0]?.type
        });
    };

    const handleImageChange = async (event) => {
        let logo = event.target.files[0];
        if (event.target.files) {
            const newAttachment = [];
            for (const file of event.target.files) {
                newAttachment.push(file);
            }
            setAttachment(newAttachment);
        }

        let maxSizeInBytes = 5 * 1024 * 1024;
        if (logo) {
            let logoUrl = URL.createObjectURL(logo);
            let img = document.createElement("img");
            img.src = logoUrl;
            img.onload = () => {
                if (logo.size > maxSizeInBytes)
                    showMessage(`File size must be less than 5Mb`);
                else
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        firmLogo: logoUrl,
                    }));
            };
        }
        trackButtonClick('register_image_upload', {
            step: stepNo,
            file_type: event.target.files[0]?.type
        });
    };

    const restrictedForDevices = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const mobileRegex =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        const isMobile = mobileRegex.test(userAgent);
        return isMobile;
    };

    const handleNextRegister = async () => {
        if (restrictedForDevices()) {
            return showMessage("You can Login/Register on Laptop");
        }
        if (registerAs == "") return showMessage("Please select Register as");
        if (registerAs === "Advisor" && !selectedAdvisorType)
            return showMessage("Please select the advisor type");
        let stage = localStorage.getItem("cStage");
        let testType = localStorage.getItem("testType");

        if (stepNo == 1) {
            let isError = false;
            const data = formCheck?.map((field, i, arr) => {
                if (formData?.[field] !== "") return false;
                return true;
            });

            if (!isError && passwordError["password"] == "" && passwordError["confirmPassword"] == "") {
                if (data.includes(true)) showMessage("Please fill out all fields");
                else {
                    if (!isAgreed) return showMessage("Please accept the terms & conditions");

                    if (isGuestUser && (registerAs == "Advisor" || registerAs == "Investor")) {
                        let companyId = localStorage.getItem("companyId");
                        setIsLoading(true);
                        const response = await postRequest("/user/advisor2MTFHP", {
                            firstName: formData?.["firstName"],
                            lastName: formData?.["lastName"],
                            email: formData?.["email"],
                            password: formData?.["password"],
                            role: registerAs,
                            companyId: companyId,
                        });

                        if (response && response["code"] == 200) {
                            if (registerPage) {
                                const hash = response["body"];
                                dispatch(setLoginType({ emailEnabled: true, hash }));
                            } else {
                                dispatch(toggleModal({ open: "registerVerification" }));
                            }
                            showMessage(response["message"]);
                            resetStates();
                        }
                        setIsLoading(false);
                    }
                    else if (registerAs == "User") {
                        setIsLoading(true);
                        let data = { firstName: formData?.["firstName"], lastName: formData?.["lastName"], email: formData?.["email"], password: formData?.["password"], referralCode: formData?.["referralCode"], }

                        if (type && partnerId) data = { firstName: formData?.["firstName"], lastName: formData?.["lastName"], email: formData?.["email"], password: formData?.["password"], referralCode: formData?.["referralCode"], type, partnerId }

                        const response = await postRequest("/user", data);
                        if (response && response["code"] == 200) {
                            if (registerPage) {
                                const hash = response["body"];
                                dispatch(setLoginType({ emailEnabled: true, hash }));
                            } else {
                                dispatch(toggleModal({ open: "registerVerification" }));
                            }
                            showMessage(response["message"]);
                            resetStates();
                        }
                        setIsLoading(false);
                    }
                    else {
                        const response = await postRequest("/user/checkExistingUser", {
                            email: formData?.["email"],
                        });
                        if (response && response["code"] == 200) {
                            if ((registerAs == "Advisor" || registerAs == "Investor") && !isGuestUser && company?.["cName"] && company?.["cWebsite"]) {
                                setFormData({
                                    ...formData,
                                    role: registerAs,
                                    cType: company["cType"],
                                    firmName: company["cName"],
                                    website: company["cWebsite"],
                                    ukRegNo: company["ukRegNo"],
                                    firmAddress: company["cAddress"],
                                    doIncorporation: company["doIncorporation"],
                                    testType: testType ? testType : "investment",
                                    cStage: stage ? stage : "Mature",
                                });
                                setStepNo(3);
                                setWebsiteStatus("Confirmed");
                            } else setStepNo(2);
                        }
                    }
                }
            }
        }
        else if (stepNo == 2 && !isGuestUser) {
            if (companySelected && companySelected["title"]) {
                let response = await postRequest(`/company/checkExistingCompany`, {
                    ukRegNo: companySelected["company_number"],
                });
                console.log(formData['role'], "formData")
                if (response["code"] == 200) {
                    if (Object.keys(response["body"]).length > 0) {
                        if ([formData['role']].includes(response["body"]?.["cCategory"])) {
                            showMessage(response["message"]);
                            console.log(response["body"], "response");
                            setExistingAdvisor(response["body"]);
                            dispatch(toggleModal({ open: "existingAdvisor" }));
                        } else
                            showMessage(`${response["body"]?.["cName"]} is a ${response["body"]?.["cCategory"]} company. You can't add it.`);
                    } else {
                        setStepNo(3);
                        setFormData({
                            ...formData,
                            role: registerAs,
                            cType: companySelected["testType"],
                            firmName: companySelected["title"],
                            ukRegNo: companySelected["company_number"],
                            firmAddress: companySelected["address_snippet"],
                            doIncorporation: companySelected["date_of_creation"],
                            testType: testType ? testType : "growth",
                            cStage: stage ? stage : "Pre-Revenue",
                        });
                    }
                }
            }
        }
        else if (stepNo == 3 && !isGuestUser) {
            if (formData["firmName"] === "") showMessage("Please fill out Firm Name");
            else if (formData["firmAddress"] === "")
                showMessage("Please fill out the Firm Address");
            else if (formData["title"] === "")
                showMessage("Please fill out your role or job Title");
            else if (formData["phone"] === "")
                showMessage("Please fill out phone Number");
            else if (formData["website"] === "")
                showMessage("Please fill out the website");
            else if (formData["company5Words"].split(" ").length < 5)
                showMessage(
                    `Please provide 5 words that describe your ${registerAs == "Advisor" || registerAs == "Investor" ? "client" : ""
                    } company business activites`
                );
            else if (!validator.isURL(formData["website"]))
                showMessage("Please enter valid webiste URL");
            else if (websiteStatus != "Confirmed")
                showMessage("Please check and confirm company website");
            else {
                const response = await postRequest("/user/advisor", { attachment, ...formData, isParent: true, ...(registerAs == "Investor" ? { investorType: selectedInvestorType?.value } : { advisorType: selectedAdvisorType?.value }) }, false);
                if (response && response["code"] == 200) {
                    setCompany(response["body"]["newCompany"]);
                    setAdvisorHashData(response["body"]?.["hash"]);
                    setCompanySelected(response["body"]?.["newCompany"]);
                    dispatch(
                        updateCompany({
                            companySelected: response["body"]?.["newCompany"],
                            company: response["body"]?.["newCompany"],
                        })
                    );
                    if (response["body"]?.["newCompany"]?.["companyDescription"])
                        dispatch(toggleModal({ open: "descriptionPopup" }));
                    showMessage(response["message"]);
                    resetStates();
                }
                setIsLoading(false);
            }
        }
    };

    const handleBack = () => {
        if (stepNo == 2) {
            if (companySelected && companySelected["title"]) setCompanySelected({});
            else setStepNo(1);
        } else setStepNo(stepNo - 1);
    };

    const handleLogin = () => {
        trackButtonClick('register_to_login_redirect');
        navigate('/login');
    };

    return (
        <>
            <div
                className={`df bg1 pr brne bscov register-not-sure-sec df fww registerCustomSection`}
                style={{ backgroundImage: `url(${require("../../../../images/landingpage/form-background-3.png")})`, minHeight: "100vh" }}>
                <div className={"register-container register-container-not-sure pr"}>
                    <div
                        ref={refs?.current?.[7]}
                        className={`tslp ${isAnimationVisible[7] ? "op1 tty0" : "op0 ttx20"}`}>
                        <p className="fw500 fs2-125rem c15" style={{ lineHeight: "40.2px" }}>Register with</p>
                        <p className="fw500 fs2-125rem c4" style={{ lineHeight: "40.2px" }}>Diligentsia for FREE</p>
                        <p className="fs1rem fw400 c15 w80 pt1rem" style={{ lineHeight: "24px" }}>
                            {registerAs == "User" ? (
                                <>
                                    {/* Explore how we can help you reach your next corporate
                                    milestone.
                                    <br /> <span>(No credit card required)</span> */}
                                </>
                            ) : registerAs == "Advisor" ? (
                                <>
                                    {" "}
                                    {stepNo === 1
                                        ? "Please register as Advisor using your professional email."
                                        : "Please enter YOUR UK firm/funds name, NOT the name of your client/investee company"}
                                </>
                            ) : registerAs == "Investor" ? (
                                <>
                                    Please enter YOUR UK firm/funds name, NOT the name of your client/investee company
                                </>
                            ) : null}
                        </p>
                    </div>
                    <div className="pt1rem pb3rem pr8rem smw60 xsw100">
                        {stepNo == 1 ? (
                            <>
                                <div className="df gg1rem pt0-5rem pb0-5rem ">
                                    <div className="pr w50">
                                        <input
                                            id="firstName"
                                            style={{ paddingLeft: "50px", paddingTop: "12px", paddingBottom: "12px", paddingRight: "1rem" }}
                                            className="lpins w100 br10px custom-input"
                                            type="text"
                                            placeholder="First Name"
                                            value={formData?.["firstName"] || ""}
                                            onChange={(e) => {
                                                if (restrictedForDevices()) { return showMessage("You can Login/Register on Laptop"); }
                                                setFormData({ ...formData, firstName: e["target"]["value"] });
                                            }}
                                        />
                                        <svg
                                            style={{ top: "17px", left: "20px" }}
                                            className="pa"
                                            width="14"
                                            height="16"
                                            viewBox="0 0 14 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M7 2C5.34314 2 4 3.34315 4 5C4 6.65683 5.34314 8 7 8C8.65683 8 10 6.65683 10 5C10 3.34315 8.65683 2 7 2ZM2.5 5C2.5 2.51472 4.51472 0.5 7 0.5C9.48528 0.5 11.5 2.51472 11.5 5C11.5 7.48528 9.48528 9.5 7 9.5C4.51472 9.5 2.5 7.48528 2.5 5ZM2.35986 11.4624C3.58257 10.6981 5.22507 10.25 7 10.25C8.77495 10.25 10.4174 10.6981 11.6402 11.4624C12.8522 12.22 13.75 13.3626 13.75 14.75C13.75 15.1642 13.4142 15.5 13 15.5C12.5858 15.5 12.25 15.1642 12.25 14.75C12.25 14.0664 11.8046 13.334 10.8452 12.7344C9.89627 12.1414 8.53878 11.75 7 11.75C5.46123 11.75 4.10372 12.1414 3.15485 12.7344C2.19543 13.334 1.75 14.0664 1.75 14.75C1.75 15.1642 1.41421 15.5 1 15.5C0.58579 15.5 0.25 15.1642 0.25 14.75C0.25 13.3626 1.14771 12.22 2.35986 11.4624Z"
                                                fill="black"
                                            />
                                        </svg>
                                    </div>
                                    <div className="pr w50">
                                        <input
                                            id="lastName"
                                            style={{ paddingLeft: "50px", paddingTop: "12px", paddingBottom: "12px", paddingRight: "1rem" }}
                                            className="lpins w100 br10px custom-input"
                                            type="text"
                                            placeholder="Last Name"
                                            value={formData?.["lastName"] || ""}
                                            onChange={(e) => {
                                                if (restrictedForDevices()) { return showMessage("You can Login/Register on Laptop"); }
                                                setFormData({ ...formData, lastName: e["target"]["value"], });
                                            }}
                                        />
                                        <svg
                                            style={{ top: "17px", left: "20px" }}
                                            className="pa"
                                            width="14"
                                            height="16"
                                            viewBox="0 0 14 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M7 2C5.34314 2 4 3.34315 4 5C4 6.65683 5.34314 8 7 8C8.65683 8 10 6.65683 10 5C10 3.34315 8.65683 2 7 2ZM2.5 5C2.5 2.51472 4.51472 0.5 7 0.5C9.48528 0.5 11.5 2.51472 11.5 5C11.5 7.48528 9.48528 9.5 7 9.5C4.51472 9.5 2.5 7.48528 2.5 5ZM2.35986 11.4624C3.58257 10.6981 5.22507 10.25 7 10.25C8.77495 10.25 10.4174 10.6981 11.6402 11.4624C12.8522 12.22 13.75 13.3626 13.75 14.75C13.75 15.1642 13.4142 15.5 13 15.5C12.5858 15.5 12.25 15.1642 12.25 14.75C12.25 14.0664 11.8046 13.334 10.8452 12.7344C9.89627 12.1414 8.53878 11.75 7 11.75C5.46123 11.75 4.10372 12.1414 3.15485 12.7344C2.19543 13.334 1.75 14.0664 1.75 14.75C1.75 15.1642 1.41421 15.5 1 15.5C0.58579 15.5 0.25 15.1642 0.25 14.75C0.25 13.3626 1.14771 12.22 2.35986 11.4624Z"
                                                fill="black"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div className="pt0-5rem pb0-5rem pr">
                                    <input
                                        id="email"
                                        style={{ paddingLeft: "50px", paddingTop: "12px", paddingBottom: "12px", paddingRight: "1rem" }}
                                        className="lpins w100 br10px custom-input"
                                        type="email"
                                        placeholder="Email - your company email address only please"
                                        value={formData?.["email"] || ""}
                                        onChange={(e) => {
                                            if (restrictedForDevices()) { return showMessage("You can Login/Register on Laptop"); }
                                            setFormData({ ...formData, email: e["target"]["value"] });
                                        }}
                                    />
                                    <svg
                                        style={{ top: "30px", left: "20px" }}
                                        className="pa"
                                        width="16"
                                        height="12"
                                        viewBox="0 0 16 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M14.1875 0.375H1.8125C1.36495 0.375 0.935725 0.55279 0.619257 0.869257C0.30279 1.18572 0.125 1.61495 0.125 2.0625V9.9375C0.125 10.3851 0.30279 10.8143 0.619257 11.1307C0.935725 11.4472 1.36495 11.625 1.8125 11.625H14.1875C14.6351 11.625 15.0643 11.4472 15.3807 11.1307C15.6972 10.8143 15.875 10.3851 15.875 9.9375V2.0625C15.875 1.61495 15.6972 1.18572 15.3807 0.869257C15.0643 0.55279 14.6351 0.375 14.1875 0.375ZM13.9456 1.5L8.24187 6.045C8.07875 6.19688 7.92125 6.19688 7.72438 6.045L2.05437 1.5H13.9456ZM14.1875 10.5H1.8125C1.66332 10.5 1.52024 10.4407 1.41475 10.3352C1.30926 10.2298 1.25 10.0867 1.25 9.9375V2.29875L6.99312 6.87187C7.26606 7.13682 7.63087 7.28597 8.01125 7.28813C8.36973 7.28661 8.71398 7.1477 8.97312 6.9L14.75 2.29875V9.9375C14.75 10.0867 14.6907 10.2298 14.5852 10.3352C14.4798 10.4407 14.3367 10.5 14.1875 10.5Z"
                                            fill="black"
                                        />
                                    </svg>
                                </div>
                                <div className="df gg1rem pt0-5rem pb0-5rem ">
                                    <div className="pr w50 password-group">
                                        <TextField
                                            id="password"
                                            className="pl1rem lpins w100 br10px p1rem custom-input"
                                            type={passwordType ? "password" : "text"}
                                            placeholder="Password"
                                            value={formData?.["password"] || ""}
                                            sx={{ height: "auto" }}
                                            onChange={(e) => {
                                                if (restrictedForDevices()) { return showMessage("You can Login/Register on Laptop"); }
                                                setFormData({ ...formData, password: e["target"]["value"] });
                                                setIsValidPassword(false);
                                                setPasswordError({ password: "", confirmPassword: "" });
                                            }}
                                            onBlur={(e) => handlePasswordBlur("password")}
                                            required
                                            error={!!passwordError["password"]}
                                            helperText={passwordError["password"]}
                                        />
                                        {!passwordType ? (
                                            <svg
                                                className="pa cp"
                                                onClick={() => setPasswordType(!passwordType)}
                                                width="27"
                                                height="21"
                                                viewBox="0 0 27 21"
                                                fill="none"
                                                xmlns="http:www.w3.org/2000/svg"
                                                style={{
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    right: "12px",
                                                    maxWidth: '20px'
                                                }}
                                            >
                                                <path
                                                    d="M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z"
                                                    fill="#404040"
                                                />
                                            </svg>
                                        ) : (
                                            <svg
                                                className="pa cp"
                                                onClick={() => setPasswordType(!passwordType)}
                                                width="27"
                                                height="21"
                                                viewBox="0 0 27 21"
                                                fill="none"
                                                xmlns="http:www.w3.org/2000/svg"
                                                style={{
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    right: "12px",
                                                    maxWidth: '20px'
                                                }}
                                            >
                                                <path
                                                    d="M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z"
                                                    fill="#404040"
                                                />
                                                <path
                                                    d="M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z"
                                                    fill="#404040"
                                                />
                                            </svg>
                                        )}
                                        <svg
                                            className="pa"
                                            style={{
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                left: "20px",
                                            }}
                                            width="18"
                                            height="18"
                                            viewBox="0 0 18 18"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g clip-path="url(#clip0_684_21433)">
                                                <path
                                                    d="M11.8828 12.8672C12.2711 12.8672 12.5859 12.5524 12.5859 12.1641C12.5859 11.7757 12.2711 11.4609 11.8828 11.4609C11.4945 11.4609 11.1797 11.7757 11.1797 12.1641C11.1797 12.5524 11.4945 12.8672 11.8828 12.8672Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M8.36716 16.5937H2.81249C2.03709 16.5937 1.40624 15.9628 1.40624 15.1874V9.42184C1.40624 8.64643 2.03709 8.01559 2.81249 8.01559H12.9374C13.7129 8.01559 14.3437 8.64643 14.3437 9.42184V10.8281C14.3437 11.2164 14.6585 11.5312 15.0468 11.5312C15.4352 11.5312 15.7499 11.2164 15.7499 10.8281V9.42184C15.7499 7.87103 14.4883 6.60935 12.9374 6.60935H12.0924V4.12965C12.0924 1.85255 10.1999 0 7.87367 0C5.54746 0 3.65493 1.85255 3.65493 4.12965V6.60935H2.81249C1.26168 6.60935 0 7.87103 0 9.42184V15.1874C0 16.7382 1.26168 17.9999 2.81249 17.9999H8.36716C8.75549 17.9999 9.07028 17.6851 9.07028 17.2968C9.07028 16.9085 8.75549 16.5937 8.36716 16.5937ZM5.06118 4.12965C5.06118 2.62795 6.32286 1.40624 7.87367 1.40624C9.42447 1.40624 10.6862 2.62795 10.6862 4.12965V6.60935H5.06118V4.12965Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M17.7067 11.4518C17.3909 11.2257 16.9517 11.2984 16.7257 11.6142L13.26 16.4552C13.1653 16.565 13.0467 16.5887 12.9832 16.5929C12.918 16.5972 12.7925 16.5889 12.682 16.4853L10.4423 14.2996C10.1643 14.0283 9.71917 14.0338 9.44798 14.3117C9.17675 14.5896 9.18216 15.0348 9.4601 15.306L11.7038 17.4956C11.7059 17.4976 11.708 17.4996 11.7101 17.5016C12.0464 17.8219 12.4954 18 12.9574 18C12.9971 18 13.0369 17.9987 13.0766 17.996C13.5799 17.9625 14.0497 17.7178 14.3657 17.3247C14.3738 17.3145 14.3817 17.3041 14.3893 17.2935L17.8691 12.4328C18.0951 12.1171 18.0224 11.6778 17.7067 11.4518Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M9.21093 12.8672C9.59926 12.8672 9.91406 12.5524 9.91406 12.1641C9.91406 11.7757 9.59926 11.4609 9.21093 11.4609C8.82261 11.4609 8.50781 11.7757 8.50781 12.1641C8.50781 12.5524 8.82261 12.8672 9.21093 12.8672Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M3.9375 12.8672C4.32582 12.8672 4.64062 12.5524 4.64062 12.1641C4.64062 11.7757 4.32582 11.4609 3.9375 11.4609C3.54917 11.4609 3.23438 11.7757 3.23438 12.1641C3.23438 12.5524 3.54917 12.8672 3.9375 12.8672Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M6.57422 12.8672C6.96254 12.8672 7.27734 12.5524 7.27734 12.1641C7.27734 11.7757 6.96254 11.4609 6.57422 11.4609C6.18589 11.4609 5.87109 11.7757 5.87109 12.1641C5.87109 12.5524 6.18589 12.8672 6.57422 12.8672Z"
                                                    fill="black"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_684_21433">
                                                    <rect width="18" height="18" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div className="pr w50 password-group">
                                        <TextField
                                            id="confirmPassword"
                                            className="pl1rem lpins w100 br10px p1rem custom-input"
                                            type={confirmPasswordType ? "password" : "text"}
                                            placeholder="Confirm Password"
                                            sx={{ height: "auto" }}
                                            value={formData?.["confirmPassword"] || ""}
                                            onChange={(e) => {
                                                if (restrictedForDevices()) { return showMessage("You can Login/Register on Laptop"); }

                                                setFormData({ ...formData, confirmPassword: e["target"]["value"] });
                                                setIsValidPassword(false);
                                                setPasswordError({ password: "", confirmPassword: "" });
                                            }}
                                            onBlur={(e) => handlePasswordBlur("confirmPassword")}
                                            required
                                            error={!!passwordError["confirmPassword"]}
                                            helperText={passwordError["confirmPassword"]}
                                        />
                                        {!confirmPasswordType ? (
                                            <svg
                                                className="pa cp"
                                                onClick={() => setConfirmPasswordType(!confirmPasswordType)}
                                                width="27"
                                                height="21"
                                                viewBox="0 0 27 21"
                                                fill="none"
                                                xmlns="http:www.w3.org/2000/svg"
                                                style={{ top: "50%", transform: "translateY(-50%)", right: "12px", maxWidth: '20px' }}
                                            >
                                                <path
                                                    d="M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z"
                                                    fill="#404040"
                                                />
                                            </svg>
                                        ) : (
                                            <svg
                                                className="pa cp"
                                                onClick={() => setConfirmPasswordType(!confirmPasswordType)}
                                                width="27"
                                                height="21"
                                                viewBox="0 0 27 21"
                                                fill="none"
                                                xmlns="http:www.w3.org/2000/svg"
                                                style={{ top: "50%", transform: "translateY(-50%)", right: "12px", maxWidth: '20px' }}
                                            >
                                                <path
                                                    d="M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z"
                                                    fill="#404040"
                                                />
                                                <path
                                                    d="M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z"
                                                    fill="#404040"
                                                />
                                            </svg>
                                        )}
                                        <svg
                                            className="pa"
                                            style={{ top: "50%", transform: "translateY(-50%)", left: "20px" }}
                                            width="18"
                                            height="18"
                                            viewBox="0 0 18 18"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g clip-path="url(#clip0_684_21433)">
                                                <path
                                                    d="M11.8828 12.8672C12.2711 12.8672 12.5859 12.5524 12.5859 12.1641C12.5859 11.7757 12.2711 11.4609 11.8828 11.4609C11.4945 11.4609 11.1797 11.7757 11.1797 12.1641C11.1797 12.5524 11.4945 12.8672 11.8828 12.8672Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M8.36716 16.5937H2.81249C2.03709 16.5937 1.40624 15.9628 1.40624 15.1874V9.42184C1.40624 8.64643 2.03709 8.01559 2.81249 8.01559H12.9374C13.7129 8.01559 14.3437 8.64643 14.3437 9.42184V10.8281C14.3437 11.2164 14.6585 11.5312 15.0468 11.5312C15.4352 11.5312 15.7499 11.2164 15.7499 10.8281V9.42184C15.7499 7.87103 14.4883 6.60935 12.9374 6.60935H12.0924V4.12965C12.0924 1.85255 10.1999 0 7.87367 0C5.54746 0 3.65493 1.85255 3.65493 4.12965V6.60935H2.81249C1.26168 6.60935 0 7.87103 0 9.42184V15.1874C0 16.7382 1.26168 17.9999 2.81249 17.9999H8.36716C8.75549 17.9999 9.07028 17.6851 9.07028 17.2968C9.07028 16.9085 8.75549 16.5937 8.36716 16.5937ZM5.06118 4.12965C5.06118 2.62795 6.32286 1.40624 7.87367 1.40624C9.42447 1.40624 10.6862 2.62795 10.6862 4.12965V6.60935H5.06118V4.12965Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M17.7067 11.4518C17.3909 11.2257 16.9517 11.2984 16.7257 11.6142L13.26 16.4552C13.1653 16.565 13.0467 16.5887 12.9832 16.5929C12.918 16.5972 12.7925 16.5889 12.682 16.4853L10.4423 14.2996C10.1643 14.0283 9.71917 14.0338 9.44798 14.3117C9.17675 14.5896 9.18216 15.0348 9.4601 15.306L11.7038 17.4956C11.7059 17.4976 11.708 17.4996 11.7101 17.5016C12.0464 17.8219 12.4954 18 12.9574 18C12.9971 18 13.0369 17.9987 13.0766 17.996C13.5799 17.9625 14.0497 17.7178 14.3657 17.3247C14.3738 17.3145 14.3817 17.3041 14.3893 17.2935L17.8691 12.4328C18.0951 12.1171 18.0224 11.6778 17.7067 11.4518Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M9.21093 12.8672C9.59926 12.8672 9.91406 12.5524 9.91406 12.1641C9.91406 11.7757 9.59926 11.4609 9.21093 11.4609C8.82261 11.4609 8.50781 11.7757 8.50781 12.1641C8.50781 12.5524 8.82261 12.8672 9.21093 12.8672Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M3.9375 12.8672C4.32582 12.8672 4.64062 12.5524 4.64062 12.1641C4.64062 11.7757 4.32582 11.4609 3.9375 11.4609C3.54917 11.4609 3.23438 11.7757 3.23438 12.1641C3.23438 12.5524 3.54917 12.8672 3.9375 12.8672Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M6.57422 12.8672C6.96254 12.8672 7.27734 12.5524 7.27734 12.1641C7.27734 11.7757 6.96254 11.4609 6.57422 11.4609C6.18589 11.4609 5.87109 11.7757 5.87109 12.1641C5.87109 12.5524 6.18589 12.8672 6.57422 12.8672Z"
                                                    fill="black"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_684_21433">
                                                    <rect width="18" height="18" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                                <div className="fw500 fs1-125rem c15 pt1rem pb0-5rem" style={{ lineHeight: "22.39px" }}>Register as</div>
                                <div className="df pt0-5rem pb1rem gg1rem registerAs">
                                    <div className="df aic">
                                        <input
                                            id="user"
                                            name="registerAs"
                                            style={{ height: "19px", width: "19px" }}
                                            type="radio"
                                            value="User"
                                            checked={registerAs == "User"}
                                            onChange={(e) => { handleRegisterAs(e["target"]["value"]) }}
                                        />
                                        <label className="fw400 fs1rem ml0-5rem c15" for="user" style={{ lineHeight: "22.39px" }}>Company</label>
                                    </div>
                                    <div className="df aic">
                                        <input
                                            id="advisor"
                                            type="radio"
                                            value="Advisor"
                                            name="registerAs"
                                            checked={registerAs == "Advisor"}
                                            style={{ height: "19px", width: "19px" }}
                                            class={type == 'Superflow' && 'cna bg14'}
                                            onChange={(e) => { type !== 'Superflow' && handleRegisterAs(e["target"]["value"]) }}
                                        />
                                        <label for="advisor" className={`fw400 fs1rem ml0-5rem ${type == 'Superflow' ? 'c12' : 'c15'}`} style={{ lineHeight: "22.39px" }}>Advisor</label>
                                    </div>
                                    <div className="df aic">
                                        <input
                                            id="investor"
                                            type="radio"
                                            value="Investor"
                                            name="registerAs"
                                            checked={registerAs == "Investor"}
                                            style={{ height: "19px", width: "19px" }}
                                            class={type == 'Superflow' && 'cna bg14'}
                                            onChange={(e) => { type !== 'Superflow' && handleRegisterAs(e["target"]["value"]) }}
                                        />
                                        <label for="investor" className={`fw400 fs1rem ml0-5rem ${type == 'Superflow' ? 'c12' : 'c15'}`} style={{ lineHeight: "22.39px" }}>Investor</label>
                                    </div>
                                    {advisorType ? (
                                        <div className="w50 react-custom-select">
                                            <Select
                                                placeholder="Select Advisor Type"
                                                styles={customStyles}
                                                value={selectedAdvisorType}
                                                className="p0-5rem mdp0-25rem lpins w100 br10px custom-input cp bg1"
                                                components={{ Option: CustomOption }}
                                                options={advisorsCategories}
                                                onChange={(value) => { setSelectedAdvisorType(value) }}
                                            />
                                        </div>
                                    ) : null}

                                    {investorType ? (
                                        <div className="w50 react-custom-select">
                                            <Select
                                                placeholder="Select Investor Type"
                                                styles={customStyles}
                                                value={selectedInvestorType}
                                                className="p0-5rem mdp0-25rem lpins w100 br10px custom-input cp bg1"
                                                components={{ Option: CustomOption }}
                                                options={investorsCategories}
                                                onChange={(value) => { setSelectedInvestorType(value) }}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                                <label className="pt1rem pb1rem df cp" for="registerTerms">
                                    <span className="checkbox w2rem h2rem pr inputWrapper">
                                        <input
                                            id="registerTerms"
                                            className="bo5 bw2px bss cp td250 w2rem h2rem br10px lpins"
                                            type="checkbox"
                                            checked={isAgreed}
                                            onChange={() => setIsAgreed(!isAgreed)}
                                        />
                                    </span>
                                    <span className="fs1rem lh3 ml1rem usn fw400 registerTerms" style={{ lineHeight: "28px" }}>
                                        I agree to &nbsp;
                                        <Link className="c3 c4-hover td250 fw500" to="/terms-conditions" target="_blank">
                                            terms and conditions &nbsp;
                                        </Link>
                                        and &nbsp;
                                        <Link className="c3 c4-hover td250 fw500" to="/policy" target="_blank">
                                            policies
                                        </Link>
                                    </span>
                                </label>
                            </>
                        ) : stepNo == 2 && !isGuestUser ? (
                            <>
                                <div className={`pr mb1-5rem ${(formData?.["firmName"] == "" || companyOptions.length == 0) && "company-searchbox"}`}>
                                    {Object.keys(companySelected).length == 0 && (
                                        <>
                                            <div className="pt0-5rem pb0-5rem pr">
                                                <input
                                                    id="searchCompany"
                                                    name="firmName"
                                                    className="pl4rem lpins w100 br10px p1rem custom-input"
                                                    type="text"
                                                    placeholder={registerAs == "User" && stepNo !== 1 ? "Please add the name of your company" : ((registerAs == "Advisor" || registerAs == "Investor") && stepNo !== 1) ? "Please add the name of YOUR UK firm/company, NOT your client/investee company" : ''}
                                                    value={formData?.["firmName"] || ""}
                                                    onChange={(e) => setFormData({ ...formData, firmName: e["target"]["value"], })}
                                                    onKeyUp={searchCompanyTimeout}
                                                />
                                                <svg
                                                    className="center-vertically f3 pa l0 ml1rem w2rem"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                >
                                                    <path
                                                        className="fa-primary"
                                                        d="M512 144v288c0 26.5-21.5 48-48 48h-416C21.5 480 0 458.5 0 432v-288C0 117.5 21.5 96 48 96h416C490.5 96 512 117.5 512 144z"
                                                    />
                                                    <path
                                                        className="fa-secondary"
                                                        d="M176 96H128V48C128 21.5 149.5 0 176 0h160C362.5 0 384 21.5 384 48V96h-48V48h-160V96z"
                                                    />
                                                </svg>
                                            </div>
                                        </>
                                    )}
                                    {companySelected && companySelected["title"] ? (
                                        <>
                                            <div className="shadow bg1 br10px p1rem mb0-5rem dg gg0-5rem">
                                                <h2 className="c4 fs1-5rem ttu w100 tac">
                                                    Company Info
                                                </h2>
                                                <span className='c15'>
                                                    <b>Company Status:</b>{" "}
                                                    {companySelected["company_status"].toUpperCase()}{" "}
                                                </span>
                                                <span className='c15'>
                                                    <b>Company Number:</b>{" "}
                                                    {companySelected["company_number"]}{" "}
                                                </span>
                                                <span className='c15'>
                                                    <b>Company Title:</b> {companySelected["title"]}{" "}
                                                </span>
                                                <span className='c15'>
                                                    <b>Company Date of Creation:</b>{" "}
                                                    {companySelected["date_of_creation"]}{" "}
                                                </span>
                                                <span className='c15'>
                                                    <b>Company Description:</b>{" "}
                                                    {companySelected["description"]}{" "}
                                                </span>
                                                <span className='c15'>
                                                    <b>Company Address:</b>{" "}
                                                    {companySelected["address_snippet"]}{" "}
                                                </span>
                                            </div>
                                        </>
                                    ) : formData?.["firmName"] != "" &&
                                        companyOptions.length > 0 ? (
                                        <>
                                            {companyOptions.map((option, idx) => (
                                                <div
                                                    key={idx}
                                                    onClick={() => setCompanySelected(option)}
                                                    className="cp df fww jcfs aic shadow bg1 br5px p1rem mb0-5rem"
                                                >
                                                    <span className="fw600 mr1rem c15">
                                                        {option["title"]}
                                                    </span>
                                                    <span className="mr1rem c15">
                                                        {option["company_number"]}
                                                    </span>
                                                    <span className="ttu fw600 c15">
                                                        {option["company_status"]}
                                                    </span>
                                                </div>
                                            ))}
                                        </>
                                    ) : (
                                        // <div className='df jcc mt5rem'>
                                        //     <p className='empty-text'>Please enter a firm name to search for UK businesses.</p>
                                        // </div>
                                        <></>
                                    )}
                                </div>
                            </>
                        ) : stepNo == 3 && !isGuestUser ? (
                            <>
                                <div className="company-searchbox">
                                    <div className="pt0-5rem pb0-5rem pr">
                                        <input
                                            id="firmName"
                                            name="firmName"
                                            className="pl4rem lpins w100 br10px p1rem custom-input"
                                            type="text"
                                            placeholder="Firm Name"
                                            value={formData?.["firmName"] || ""}
                                            onChange={(e) => setFormData({ ...formData, firmName: e["target"]["value"], })}
                                        />
                                        <svg
                                            viewBox="0 0 1024 1024"
                                            className="center-vertically f3 pa l0 ml1rem w2rem"
                                        >
                                            <path
                                                d="M564.2 138.8c0.1-10.3-10.5-17.4-20.6-13.9L212.7 243.6c-6 2.1-10 7.7-10 13.9v572.6h361.5V138.8zM359.8 716.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-86.8c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-91.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.5c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.4c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m135.8 357c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-86.8c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-91.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.5c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.4c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-87.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3V272zM838.2 338.3c0.1-5.5-3-10.5-7.9-13.1L613.4 211.6c-10.2-5.4-22.6 1.9-22.6 13.1v605.5h247.4V338.3z m-83.6 378c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-86.8c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-91.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.5c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.4c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z"
                                                fill="#66AFFF"
                                            />
                                            <path d="M876 900.8H147.2c-8.4 0-15.2-8-15.2-17.7v-35.3c0-9.7 6.8-17.7 15.2-17.7H876c8.4 0 15.2 8 15.2 17.7v35.3c0 9.8-6.8 17.7-15.2 17.7z" />
                                        </svg>
                                    </div>
                                    <div className="pt0-5rem pb0-5rem pr">
                                        <input
                                            id="firmAddress"
                                            name="firmAddress"
                                            className="pl4rem lpins w100 br10px p1rem custom-input"
                                            type="text"
                                            placeholder="Firm Address"
                                            value={formData?.["firmAddress"] || ""}
                                            onChange={(e) =>
                                                setFormData({ ...formData, firmAddress: e["target"]["value"] })
                                            }
                                        />
                                        <svg
                                            viewBox="0 0 256 256"
                                            className="center-vertically f3 pa l0 ml1rem w2rem"
                                        >
                                            <g>
                                                <g>
                                                    <path
                                                        className="fa-secondary"
                                                        d="M42.1,122.7h37.7v8.9H42.1V122.7L42.1,122.7z"
                                                    />
                                                    <path
                                                        className="fa-primary"
                                                        d="M42.1,147h37.7v8.9H42.1V147L42.1,147z"
                                                    />
                                                    <path d="M42.1,172h37.7v8.9H42.1V172L42.1,172z" />
                                                    <path d="M42.1,197.1h37.7v8.9H42.1V197.1L42.1,197.1z" />
                                                    <path d="M107.1,74.6h60.3v8.9h-60.3V74.6z" />
                                                    <path d="M107.1,103.7h32.6v8.9h-32.6V103.7z" />
                                                    <path d="M107.1,132.8h18.7v8.9h-18.7V132.8z" />
                                                    <path d="M200.1,145.3c0-9.3-7.6-17-17-17s-16.9,7.6-16.9,17c0,9.3,7.6,17,16.9,17C192.5,162.2,200.1,154.6,200.1,145.3z M183.1,153.4c-4.5,0-8.1-3.6-8.1-8.1c0-4.5,3.6-8.1,8.1-8.1c4.5,0,8.1,3.6,8.1,8.1C191.3,149.7,187.6,153.4,183.1,153.4z" />
                                                    <path d="M190,223c4.2-5.3,11.6-15,18.9-25.9c15.1-22.6,22.8-39.7,22.8-50.7c0-26.8-21.8-48.6-48.6-48.6s-48.6,21.8-48.6,48.6c0,11,7.7,28.1,22.8,50.7c7.3,10.9,14.7,20.6,18.9,25.9h-25.1h-25.7v-26.3h18.8v-8.9h-27.6V223h-19V96.8V50.5h51.4h27.8v38.9h8.9V41.7h-36.7V24.1H88.8v17.6v8.9v28.6h-53v17.6H24.3V223H10v8.9h14.2h64.6h8.9h19h34.6h30.2H246V223H190z M97.7,32.9h42.6v8.7H97.7V32.9z M44.7,88h42.6v8.7H44.7V88z M33.1,223V105.6h2.7h53V223H33.1z M143.4,146.4c0-21.9,17.8-39.7,39.8-39.7c21.9,0,39.8,17.8,39.8,39.7c0,17.1-26.1,53.8-39.8,71.1C169.5,200.2,143.4,163.5,143.4,146.4z" />
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                    <div className="pt0-5rem pb0-5rem pr">
                                        <input
                                            id="title"
                                            name="title"
                                            className="pl4rem lpins w100 br10px p1rem custom-input"
                                            type="text"
                                            placeholder="Your Title"
                                            value={formData?.["title"] || ""}
                                            onChange={(e) => setFormData({ ...formData, title: e["target"]["value"] })}
                                        />
                                        <svg
                                            viewBox="0 0 367.004 367.004"
                                            className="center-vertically f3 pa l0 ml1rem w2rem"
                                        >
                                            <g>
                                                <path
                                                    className="fa-primary"
                                                    d="M160.937,197.203c24.125,0,80.846-29.033,80.846-98.603c0-9.705-0.236-19.081-1.037-27.94
                                                    c-1.313-17.427-4.883-32.872-13.768-44.71C215.578,9.838,195.629,0,160.937,0c-34.68,0-54.628,9.833-66.029,25.937
                                                    C86.012,37.778,82.44,53.231,81.127,70.669c-0.799,8.856-1.035,18.229-1.035,27.932C80.092,168.17,136.812,197.203,160.937,197.203
                                                    z M187.328,36.123c-2.355,5.951-3.535,8.926-5.891,14.877c-15.209-4.297-25.791-4.297-41,0c-2.355-5.951-3.533-8.926-5.891-14.877
                                                    C153.566,30.365,168.308,30.365,187.328,36.123z M92.119,83.517c0.932,2.037,4.889,9.869,11.014,10.604
                                                    c7.041,0.844,18.729-24.936,57.805-24.998c39.076,0.063,50.764,25.842,57.805,24.998c6.125-0.735,10.082-8.567,11.014-10.604
                                                    c0.189,4.992,0.259,10.046,0.259,15.084c0,34.006-15.015,55.076-27.612,66.763c-15.871,14.726-33.492,20.071-41.465,20.071
                                                    c-7.973,0-25.594-5.345-41.465-20.071c-12.598-11.687-27.612-32.757-27.612-66.763C91.86,93.562,91.93,88.509,92.119,83.517z"
                                                />
                                                <path
                                                    className="fa-primary"
                                                    d="M232.705,211.768c2.605-2.606,5.371-4.994,8.26-7.181c-11.223-6.117-22.109-11.933-29.153-15.697l-0.331-0.177
                                                    c-1.982-1.059-4.403-0.847-6.169,0.541c-9.085,7.132-19.035,11.938-29.574,14.283c-1.861,0.414-3.391,1.738-4.066,3.521
                                                    l-10.734,28.291l-10.734-28.291c-0.675-1.783-2.204-3.106-4.066-3.521c-10.539-2.346-20.489-7.152-29.573-14.283
                                                    c-1.769-1.388-4.188-1.601-6.17-0.541c-17.138,9.158-58.25,31.302-69.829,39.106c-19.621,13.219-28.199,61.053-29.72,70.508
                                                    c-0.15,0.938-0.064,1.898,0.253,2.793c0.703,1.982,18.709,48.548,149.84,48.548c5.933,0,11.627-0.098,17.105-0.28
                                                    c0.481-6.064,3.029-11.993,7.657-16.622l31.512-31.511C203.113,271.581,208.833,235.64,232.705,211.768z"
                                                />
                                                <path
                                                    className="fa-secondary"
                                                    d="M336.396,219.546c-12.79-12.79-29.821-19.834-47.957-19.834c-18.135,0-35.166,7.044-47.955,19.834
                                                    c-21.512,21.511-26.052,54.982-11.04,81.396l1.317,2.319l-37.284,37.284c-6.042,6.043-6.041,15.876,0.002,21.92
                                                    c2.927,2.927,6.819,4.539,10.958,4.539c4.142,0,8.033-1.612,10.96-4.54l37.285-37.283l2.317,1.315
                                                    c10.126,5.748,21.698,8.787,33.464,8.787c18.127,0,35.149-7.04,47.933-19.824c12.791-12.79,19.835-29.822,19.835-47.957
                                                    C356.231,249.367,349.187,232.336,336.396,219.546z M319.779,298.842c-8.357,8.358-19.488,12.962-31.339,12.962
                                                    c-11.851,0-22.982-4.603-31.341-12.962c-17.281-17.281-17.281-45.399,0-62.68c8.359-8.359,19.49-12.962,31.341-12.962
                                                    c11.851,0,22.981,4.604,31.339,12.963c8.359,8.358,12.963,19.488,12.963,31.339S328.138,290.483,319.779,298.842z"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                    <div className="pt0-5rem pb0-5rem pr">
                                        <Input
                                            name="phone"
                                            className="pl4rem lpins w100 br10px p1rem custom-input"
                                            country="GB"
                                            international
                                            placeholder="Your Phone Number"
                                            withCountryCallingCode
                                            value={formData?.["phone"]}
                                            onChange={(e) => setFormData({ ...formData, phone: e })}
                                        />
                                        <svg
                                            className="center-vertically f3 pa l0 ml1rem w2rem"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 384 512"
                                        >
                                            <path
                                                className="fa-primary"
                                                d="M352 48V384H32V48C32 21.5 53.5 0 80 0h224C330.5 0 352 21.5 352 48z"
                                            />
                                            <path
                                                className="fa-secondary"
                                                d="M32 384v80C32 490.5 53.5 512 80 512h224c26.5 0 48-21.5 48-48V384H32zM240 447.1C240 456.8 232.8 464 224 464H159.1C151.2 464 144 456.8 144 448S151.2 432 160 432h64C232.8 432 240 439.2 240 447.1z"
                                            />
                                        </svg>
                                    </div>
                                    <div className="pt0-5rem pb0-5rem pr">
                                        {websiteStatus == "Check" ? (
                                            <input
                                                className="verify-btn shadow shadow bg9 c1 p1rem fw600 cp ttu"
                                                type="button"
                                                value={websiteStatus}
                                                onClick={() => verifyWebsite()}
                                            />
                                        ) : websiteStatus == "Confirm" ? (
                                            <>
                                                <input
                                                    className="verify-btn shadow bg8 c1 p1rem fw600 cp ttu"
                                                    type="button"
                                                    value={websiteStatus}
                                                    onClick={() => setWebsiteStatus("Confirmed")}
                                                />
                                            </>
                                        ) : (
                                            <input
                                                className="verify-btn shadow shadow bg7 c1 p1rem fw600 ttu"
                                                type="button"
                                                value={websiteStatus}
                                            />
                                        )}
                                        <input
                                            id="companyWebsite"
                                            name="website"
                                            className="pl4rem lpins w100 br10px p1rem custom-input"
                                            type="text"
                                            placeholder="Website"
                                            value={formData?.["website"] || ""}
                                            onChange={(e) => { setFormData({ ...formData, website: e["target"]["value"] }), setWebsiteStatus("Check") }}
                                        />
                                        <svg
                                            viewBox="0 0 512 512"
                                            className="center-vertically f3 pa l0 ml1rem w2rem"
                                        >
                                            <g>
                                                <g>
                                                    <path
                                                        d="M256,0C114.62,0,0,114.62,0,256s114.62,256,256,256s256-114.62,256-256S397.38,0,256,0z M172.211,41.609
                                                        c-24.934,27.119-44.68,66.125-56.755,111.992H49.749C75.179,102.741,118.869,62.524,172.211,41.609z M25.6,256
                                                        c0-26.999,5.077-52.727,13.662-76.8h70.494c-4.608,24.294-7.356,49.963-7.356,76.8s2.748,52.506,7.347,76.8H39.262
                                                        C30.677,308.727,25.6,283,25.6,256z M49.749,358.4h65.707c12.083,45.867,31.821,84.872,56.755,111.991
                                                        C118.869,449.476,75.179,409.259,49.749,358.4z M243.2,485.188c-43.81-8.252-81.877-58.24-101.359-126.788H243.2V485.188z
                                                        M243.2,332.8H135.74c-4.924-24.166-7.74-49.997-7.74-76.8s2.816-52.634,7.74-76.8H243.2V332.8z M243.2,153.6H141.841
                                                        C161.323,85.052,199.39,35.063,243.2,26.812V153.6z M462.251,153.6h-65.707c-12.083-45.867-31.821-84.873-56.755-111.992
                                                        C393.131,62.524,436.821,102.741,462.251,153.6z M268.8,26.812c43.81,8.252,81.877,58.24,101.359,126.788H268.8V26.812z
                                                        M268.8,179.2h107.46c4.924,24.166,7.74,49.997,7.74,76.8s-2.816,52.634-7.74,76.8H268.8V179.2z M268.8,485.188V358.4h101.359
                                                        C350.677,426.948,312.61,476.937,268.8,485.188z M339.789,470.391c24.934-27.127,44.672-66.125,56.755-111.991h65.707
                                                        C436.821,409.259,393.131,449.476,339.789,470.391z M402.244,332.8c4.608-24.294,7.356-49.963,7.356-76.8
                                                        s-2.748-52.506-7.347-76.8h70.494c8.576,24.073,13.653,49.801,13.653,76.8c0,27-5.077,52.727-13.662,76.8H402.244z"
                                                    />
                                                </g>
                                            </g>
                                        </svg>
                                    </div>

                                    <div className="pr mb1rem">
                                        <input
                                            id="company5Words"
                                            name="company5Keywords"
                                            type="text"
                                            placeholder={`Add 5 keywords which define this company's activities`}
                                            className="pl4rem shadow bg5 w100 br5px p1rem"
                                            value={formData?.["company5Words"]}
                                            onChange={(e) => setFormData({ ...formData, company5Words: e["target"]["value"] })
                                            }
                                        />
                                        <svg
                                            className="center-vertically f3 pa l0 ml1rem w2rem"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                        >
                                            <path
                                                className="fa-primary"
                                                d="M23.1 512c-6.156 0-12.28-2.344-16.97-7.031c-9.375-9.375-9.375-24.56 0-33.94l303.1-303.1c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-303.1 303.1C36.28 509.7 30.16 512 23.1 512z"
                                            />
                                            <path
                                                className="fa-secondary"
                                                d="M467.1 241.1L351.1 288h94.34c-7.711 14.85-16.29 29.28-25.87 43.01l-132.5 52.99h85.65c-59.34 52.71-144.1 80.35-264.5 52.82l235.9-235.9c9.375-9.375 9.375-24.56 0-33.94s-24.56-9.375-33.94 0L75.11 402.1C-2.957 61.97 362.5 8.436 478.9 .0846c18.87-1.354 34.41 14.19 33.05 33.05C508.7 78.53 498.5 161.8 467.1 241.1z"
                                            />
                                        </svg>
                                    </div>
                                    <div className="pl1rem lpins br10px p1rem custom-input mt1rem bg1 pr">
                                        <label className="df mb0-5rem">Firm Logo</label>
                                        {formData?.["firmLogo"] == "" ? (
                                            <label
                                                onDragOver={onDragOver}
                                                onDrop={(e) => onDrop(e)}
                                                for="fileUpload"
                                                className="w100 bsbb bg5 br5px df jcc aic px2rem py5rem bsd bo6 bw2px cp mb0-5rem"
                                            >
                                                <span className="pen fs0-75rem fw500 tac">
                                                    Click here or drag and drop files (Max 160x160)
                                                </span>
                                                <input
                                                    onChange={handleImageChange}
                                                    className="dn"
                                                    id="fileUpload"
                                                    type="file"
                                                    accept="image/*"
                                                />
                                            </label>
                                        ) : (
                                            <>
                                                <button
                                                    className="close-popup c3"
                                                    onClick={() => setFormData((prevFormData) => ({ ...prevFormData, firmLogo: "" }))
                                                    }
                                                >
                                                    <svg
                                                        viewBox="0 0 256 256"
                                                        style={{ position: "relative", top: "4px" }}
                                                        className="pen fds h1rem f1 mr0-5rem"
                                                    >
                                                        <g>
                                                            <g>
                                                                <g>
                                                                    <path
                                                                        className="pen fa-primary"
                                                                        d="M94.6,3.6c-5.7,1.5-10.5,5.6-13.3,11.2l-1.7,3.4L79.5,28l-0.2,9.7H47.5c-30.4,0-32,0-33.7,0.9c-3.4,1.8-4.9,6.8-2.7,9.7c2.2,2.8,3.3,3.3,8.8,3.5c4.8,0.2,5.1,0.2,5.4,1.2c0.1,0.6,5.6,41.9,12.3,91.9c6.6,49.9,12.2,91.4,12.4,92c0.1,0.7,1,2.7,2,4.5c2.8,5.4,7.9,9.4,13.6,10.9c2.6,0.7,10.2,0.8,62.6,0.8c65.2,0,62.8,0.1,67.7-2.8c5.6-3.3,9.8-9.4,10.8-15.6c0.2-1.6,5.7-43,12.3-91.8c6.5-48.9,11.9-89.4,12-89.9c0.2-1,0.6-1,5.3-1.2c4.3-0.1,5.4-0.3,6.5-1.2c2.3-1.7,3.3-3.4,3.3-5.7c0-2.7-1.3-4.9-3.6-6.2c-1.8-1-2.3-1-33.8-1h-31.9l-0.2-9.7l-0.1-9.7l-1.7-3.4c-2.8-5.7-7.7-9.7-13.6-11.2C156.9,2.5,98.8,2.5,94.6,3.6z M159.3,18.1c2.8,1.7,3.1,2.9,3.1,11.8v7.9H128H93.7v-7.9c0-8.8,0.3-10.1,3.1-11.8c1.5-0.9,2.7-1,31.3-1C156.6,17.1,157.8,17.1,159.3,18.1z M216.3,55c-0.2,1.7-5.7,42.7-12.1,91.1c-9,67.4-11.9,88.3-12.6,89.4c-0.4,0.8-1.7,2-2.7,2.5c-1.9,1-1.9,1-60.9,1c-53.2,0-59.2-0.1-60.7-0.8c-3.6-1.7-2.6,4.2-15.7-93.9C45.1,95,39.6,54,39.5,53.3l-0.2-1.3H128h88.7L216.3,55z"
                                                                    />
                                                                    <path d="M78.2,70c-1.7,1-2.8,2.6-3.3,4.4c-0.1,0.6,1.8,32.8,4.4,71.4c3.9,57.9,4.8,70.5,5.5,72c2.6,5.3,9.9,5.2,12.5-0.1c0.9-1.8,0.8-3-3.8-72.7c-5.2-77.6-4.6-72.6-8.1-74.9C83.3,68.9,80.3,68.8,78.2,70z" />
                                                                    <path d="M124.7,69.9c-0.9,0.4-2.1,1.5-2.6,2.4c-1,1.6-1,2.4-1,73.1c0,70.9,0,71.6,1,73.1c2.6,4.2,9.2,4.2,11.8,0c1-1.6,1-2.3,1-73.1s0-71.6-1-73.1C132.1,69.4,128,68.3,124.7,69.9z" />
                                                                    <path d="M170.7,70.2c-3.5,2.3-2.9-2.7-8.1,74.8c-4.7,70-4.8,70.8-3.8,72.7c2.6,5.3,10,5.4,12.5,0.1c0.7-1.4,1.6-13.5,5.3-69.2c2.5-37.1,4.5-69.2,4.6-71.2c0.1-3.1,0-3.9-1-5.3C177.9,69,173.8,68.2,170.7,70.2z" />
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </button>
                                                <div className="df jcc">
                                                    <img
                                                        className="poupup-img shadow brw5 tac"
                                                        src={formData["firmLogo"]}
                                                        alt="Firm Logo"
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </>
                        ) : null}
                        <div className="df aic jcsb pr">
                            {registerAs != "User" && stepNo != 1 && (
                                <button
                                    style={{ width: "32%", height: "46px", lineHeight: "30px" }}
                                    className={`new-shadow df jcc aic c4 bg1 br35px cp fw600 fs1rem pr zi0 br10px bss bo4 bw2px`}
                                    onClick={() => handleBack()}
                                >
                                    <i className="icon pr mr0-5rem" style={{ top: '3px', width: '20px' }}>
                                        <svg className='cp mr1rem' width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '18px', height: '18px' }}>
                                            <path d="M7.2786 0.40705C7.40543 0.279703 7.55715 0.178129 7.7249 0.10825C7.89264 0.0383717 8.07306 0.00158847 8.25563 4.92302e-05C8.43819 -0.0014881 8.61924 0.0322472 8.78821 0.0992886C8.95719 0.16633 9.1107 0.265335 9.2398 0.390524C9.36889 0.515715 9.47098 0.664585 9.54012 0.828446C9.60925 0.992308 9.64404 1.16788 9.64245 1.34492C9.64087 1.52196 9.60294 1.69692 9.53088 1.85959C9.45882 2.02226 9.35407 2.16939 9.22275 2.29239L4.6951 6.68305L20.6251 6.68305C20.9897 6.68305 21.3394 6.82353 21.5973 7.07358C21.8551 7.32362 22 7.66276 22 8.01638C22 8.37001 21.8551 8.70914 21.5973 8.95919C21.3394 9.20924 20.9897 9.34972 20.6251 9.34972L4.6951 9.34972L9.22275 13.7404C9.47321 13.9919 9.61179 14.3287 9.60866 14.6783C9.60553 15.0278 9.46093 15.3623 9.20601 15.6095C8.95108 15.8567 8.60623 15.9969 8.24573 15.9999C7.88523 16.003 7.53792 15.8686 7.2786 15.6257L0.403938 8.95905C0.275896 8.8352 0.174307 8.68806 0.104993 8.52607C0.0356788 8.36409 -3.41367e-07 8.19043 -3.49033e-07 8.01505C-3.56699e-07 7.83967 0.0356787 7.66602 0.104993 7.50403C0.174307 7.34204 0.275896 7.19491 0.403938 7.07105L7.2786 0.40705Z" fill="#fc7785" />
                                        </svg>
                                    </i>
                                    Back
                                </button>
                            )}
                            {stepNo == 2 &&
                                !(companySelected && companySelected["title"]) ? null : (
                                <>
                                    <button
                                        style={{ width: "50%", height: "46px", lineHeight: "30px", cursor: `${!isValidPassword ? "not-allowed" : "pointer"}`, }}
                                        className={`${animation ? "registerButtonAnimation" : ""} sm-fs18px rainbow c1 bg4 br35px mt1rem mb1rem mr2-5rem cp fw600 fs1rem pr zi0 br10px xs-w100 sm-py0px ${(isLoading || !isValidPassword) && "button-disabled"} ${isLoading || !isValidPassword ? "" : "rainbow "}`}
                                        onClick={() => { if (!isLoading) { handleNextRegister(); } }}>
                                        {(!isGuestUser && (registerAs == "Advisor" || registerAs == "Investor")) ? ((stepNo === 1 || stepNo === 2) ? "Next" : "Register")
                                            : stepNo === 1 && registerAs === "User"
                                                ? <>
                                                    Register For Free
                                                    <span
                                                        className="fw400 c21 df fdc"
                                                        style={{ marginTop: "-2px", fontSize: "10px", lineHeight: "15px", fontStyle: "italic", }}>
                                                        No credit card required
                                                    </span>
                                                </>
                                                : "Register"
                                        }
                                    </button>
                                </>
                            )}
                        </div>
                        <div className="td250 cp fw600 fs1rem c15 mt0-5rem" style={{ lineHeight: "28px" }}>
                            Already registered?{" "}
                            <Link className="c3 ml0-5rem" to={ROUTES.LOGIN} onClick={() => handleLogin()}>
                                Log in
                            </Link>
                        </div>
                    </div>
                    <div className={`pa r0 b0 smr0rem smw50 ${isNotSure && "form-right-image"}`}
                        style={{ bottom: "-8px", right: isNotSure ? "-25%" : "-65%", zIndex: "9", }}>
                        {/* <img src={require('../../../../images/landingpage/from-register-female.png')} className="book-call smw70" style={{ width: '85%', }} /> */}
                    </div>
                </div>
                {/* Not Sure Section */}
                {isNotSure && (
                    <div className="not-sure-register w40">
                        <div
                            className="pr bg20 not-sure-container"
                            style={{
                                padding: "0px 160px",
                                background: 'transparent',
                                height: "100%",
                            }}
                        >
                            <div ref={refs?.current?.[8]} className={`tslp op1 tty0`}>
                                <p
                                    className="fw500 tac c15 pt3rem fs2rem"
                                    style={{ lineHeight: "1" }}
                                >
                                    Not Sure <span className="c23">Yet?</span>
                                </p>
                                <div className="w100 df jcc">
                                    <p
                                        className="fw400 tac c15 pt0-5rem fs1rem"
                                        style={{ lineHeight: "24px", width: "100%" }}
                                    >
                                        Find out by taking our FREE 2-minute Diligentsia Test. No
                                        email or credit card required.
                                    </p>
                                </div>
                            </div>
                            <div className="df jcc fdc w90 mt10rem bsbb smw100 mxa">
                                <div
                                    ref={refs?.current?.[8]}
                                    className={`bsflp bsbb bg1 br30px pr tslp pt1rem pb1rem pr1rem pl1rem df aic fdc mb3-5rem smw70 smmxa ${isAnimationVisible[8] && "scaleAnimation"
                                        }`}
                                    style={{ width: "100%" }}
                                >
                                    <div
                                        className="pa df jcc aic p2rem bg3 twoMinuteIcon"
                                        style={{
                                            top: "-49px",
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            width: "15px",
                                            height: "15px",
                                            zoom: "0.8",
                                            borderRadius: "50%",
                                        }}
                                    >
                                        <img
                                            src={require(`../../../../images/2-minute-test-icon.png`)}
                                            alt="2-minute-test-icon"
                                        />
                                    </div>
                                    <h1 className="fw500 tac c15 fs1-25rem pr0-5rem pl0-5rem mt1rem df fdc">
                                        <div>
                                            How{" "}
                                            <span className="fw700 fs1-25rem tac c15 fsi">
                                                Investment, Growth or Exit Ready
                                            </span>{" "}
                                            are you?
                                        </div>
                                    </h1>
                                    <div className="df jcc my0-5rem">
                                        <Link
                                            to={`/testPage`}
                                            onMouseEnter={() => setIsBtnHover(true)}
                                            onMouseLeave={() => setIsBtnHover(false)}
                                            className={`br35px pr cp c1-hover c4 ${!isBtnHover && ""
                                                } df jcc aic bg1 bg4-hover`}
                                            style={{
                                                transition: "background-color 0.3s ease",
                                                border: "1px solid #FC7785",
                                                padding: "10px 26px",
                                            }}
                                        >
                                            2-Minute Test
                                            <svg
                                                width="21"
                                                height="18"
                                                viewBox="0 0 21 18"
                                                fill="none"
                                                xmlns="http:www.w3.org/2000/svg"
                                                style={{
                                                    marginLeft: "10px",
                                                    stroke: isBtnHover ? "#ffff" : "#FC7785",
                                                    height: "18px",
                                                    width: "21px",
                                                }}
                                            >
                                                <path
                                                    d="M1.39612 10.331H15.818L11.43 14.7191C10.1696 15.9795 12.0602 17.87 13.3206 16.6096L17.3169 12.6071L19.9847 9.93519C20.5017 9.41507 20.5017 8.57507 19.9847 8.05496L13.3206 1.38311C13.0671 1.12258 12.7181 0.976392 12.3545 0.979416C11.1542 0.979567 10.5652 2.4415 11.43 3.2738L15.8284 7.66187H1.32711C-0.521408 7.75359 -0.383387 10.4231 1.39612 10.331Z"
                                                    fill={isBtnHover ? "#ffff" : "#FC7785"}
                                                />
                                            </svg>
                                        </Link>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                )}
            </div>

            <ModalWrapper modalCardClasses={"m0rem"} modalType={"existingAdvisor"} onCloseHandler={() => { setExistingAdvisor({}), setStepNo(2), dispatch(toggleModal({ open: "" })) }}>
                <img className="h3rem t0 l0 m1rem" src={require(`../../../../images/logo.svg`)} alt="TODO" />
                <h2 className="c15 fw600">{`Existing ${registerAs} - ${existingAdvisor["cName"]}`}</h2>
                <div className="tac my1rem oa">
                    <p className="fs1rem taj px0-5rem c43">
                        Hi {`${formData["firstName"]} ${formData["lastName"]}`}, <br />
                        We will notify <b>{existingAdvisor["contactName"]} </b> of your
                        wish to add your Diligentsia account and request that they grant
                        you access. <br />
                        <br />
                        Please click below REQUEST to grant for access
                        <br />
                        Kind Regards{" "}
                    </p>
                </div>
                <div className="df jcse">
                    <button onClick={() => requestAdvisorAccess()} className="bg3 c1 h100 mt0-5rem shadow td250 br5px px2rem fs1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic">Request</button>
                </div>

            </ModalWrapper>

            {/* Description Popup */}
            <ModalWrapper modalCardClasses={"m0rem"} modalType={"descriptionPopup"}
                girlComponent={
                    <div style={{ position: "relative", maxHeight: "90%" }}>
                        <img src="https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/girl-1730109127115.webp" alt="messageLadie" className="girlImage" />
                        <img onClick={() => { dispatch(toggleModal({ open: "introVideo" })); dispatch(setModalHistory({ modalHistory: modal["open"] })) }}
                            src={require(`../../../../images/clicktohearme.webp`)}
                            className="pa cp"
                            alt="clickToHearMe"
                            style={{ maxWidth: "130px", zIndex: 99, top: "-210px", left: "15px" }}
                        />
                    </div>
                }>
                <h1 className="fs1-5rem tas w100 lh1 c15 fw600 mb0-5rem">Company Description</h1>
                <p className="c3 fs14px w100 tas mb1rem">AI Generated</p>
                <div
                    className="df fdc fs14px c43 oya h40vh"
                    style={{
                        lineHeight: "1.8",
                        overflow: "scroll",
                        paddingRight: "14px",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundImage: `url(${require("../../../../images/aiWatermark.png")})`,
                    }}>
                    {company["companyDescription"]}
                </div>
                {/* </FadeScroll> */}
                <p className="c4 fs11px fw500 w100 tas pt1rem mb0-5rem">You can later edit description in Company Settings</p>
                <div onClick={() => { dispatch(toggleModal({ open: "" })) }} className="df jcc fdc fdr-md aic fs1rem px2rem">
                    <Link className="cp bg4 c1 mt0-5rem br50px py0-75rem px2-5rem sm-px16px db fs14px sm-fs12px fw400 tac" to={ROUTES.LOGIN}>
                        Next
                    </Link>
                </div>
            </ModalWrapper>

            {/* Advisor type modal */}
            <Modal open={modal["open"] == "advisorType"} onClose={onAdvisorModalClose} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
                <div className="mah90 oya bg1 p2rem shadow w30 bsbb df fdc maw600px br5px pr" style={{ outline: "none" }}>
                    <button className="close-popup" onClick={onAdvisorModalClose}>
                        <svg style={{ position: "relative", top: "4px" }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                            <path
                                className="pen fa-primary"
                                d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                            />
                        </svg>
                    </button>
                    <div className="df jcc fs1-5rem">Add Advisor type</div>
                    <input
                        type="text"
                        id="advisorType"
                        value={advisorTypeValue}
                        placeholder="Advisor Type"
                        style={{ paddingLeft: "50px" }}
                        onChange={(e) => setAdvisorTypeValue(e["target"]["value"])}
                        className="mt1rem pl1rem lpins w100 br10px p1rem custom-input"
                    />
                    <span className={`shadow bg3 c1 td250 br5px p0-5rem fw600 cp ttu bsbb tac mt1rem df jcc aic w50 `} style={{ backgroundColor: advisorTypeValue === "" && "lightgray", cursor: advisorTypeValue === "" ? "not-allowed" : "pointer" }}
                        onClick={() => { advisorTypeValue !== "" && onAdvisorTypeAdded() }}>
                        Add
                    </span>
                </div>
            </Modal>
        </>
    );
};

export default RegisterTwoMinuteTest;
